import { DatePipe } from '@angular/common';
import { HttpStatusCode } from '@angular/common/http';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject, combineLatest, BehaviorSubject, of } from 'rxjs';
import { distinctUntilChanged, filter, map, take, takeUntil, withLatestFrom } from 'rxjs/operators';
import { Classifications } from '../../../account-info-header/models';
import { selectAchInstructions, selectClassifications, selectCreateWireTemplateCallCompleted, selectCreateWireTemplateCallSuccessful, selectIsDemoUser, selectIsEmployee, selectIsIra, selectIsOrgAccount, selectIsUserInputRequired, selectMasterAccount, selectNraIndicator, selectPatchWireTemplateCallCompleted, selectRegType, selectSubAccountId, selectTemplatesList, selectUsername, selectUseTestTrustDigitalToPdfFlow } from '../../../account-info-header/reducers';
import { selectHasAccessInitiateMoneyMovement, selectHasAccessReleaseMoneyMovement, selectHasPositionLotsPhase2 } from '../../../authorize/reducers';
import { EAuthActions, SharedActions } from '../../../shared/actions';
import { displayCancelModal, resetCancelModal, resetCancelModalforInitiateAndReleaseTable } from '../../../shared/actions/shared.actions';
import { AdobeConstants } from '../../../shared/adobe-tagging/AdobeConstants';
import { AdobeHelpers } from '../../../shared/adobe-tagging/adobeHelper';
import { EAuthInfo } from '../../../shared/models/EAuthInfo';
import { RemoveHyphenFromAccountPipe } from '../../../shared/pipes/remove-hyphen-from-account.pipe';
import { selectAcknowledgement, selectAcknowledgementError, selectCancelModalContinueClickedForEditTweReviewPage, selectCancelModalContinueClickedTransactionReviewPage, selectEAuthInfo, selectPdf, selectPdfs, selectReviewPage, selectReviewPageSubmitClicked } from '../../../shared/reducers';
import { FeatureFlagService } from '../../../shared/services/feature-flag-service';
import { ComponentState } from '../../../shared/types/ComponentState';
import { ApiEndpointType, Constants, MediaTypeCode, PageTypes, RothConversion, RothWarnings, moneyMovementAcknowledgeError, navRouteConstants, prettierWarnings, stateCodes, stateTypeIndicators, transactionTypes, transferTypes, yesNo, formType, transactionDirection, digitalRegTypes, RegTypeCode, distributionReasons, transactionDetailLabels, frequencyTypes } from '../../../shared/utilities/Constants';
import { getArrayBufferFromBase64, openPdfInNewWindow } from '../../../shared/utilities/pdf';
import { AchActions, CheckActions, InternalTransferActions, InternalTransfersActions, ReviewPageActions, TransactionDetailsActions, WireActions } from '../../actions';
import { deleteTransactionClicked } from '../../actions/standing-authorizations-table.actions';
import { AchInfo } from '../../models/ach/AchInfo';
import { CheckInfo } from '../../models/check/CheckInfo';
import { ItExtraPrompts, ItTransactionDetails, TransactionForm, TransactionFormServiceError, WireTransactionDetails, WireForm, isItExtraPrompts, ChecksExtraPrompts, CheckTransactionDetails, CheckForm } from '../../models/form/TransactionForm';
import { AccountInfoBanner } from '../../models/internal-transfer/AccountInfoBanner';
import { InternalTransferInfo } from '../../models/internal-transfer/InternalTransferInfo';
import { ToAccountInfo } from '../../models/internal-transfer/ToAccountInfo';
import { Sloa } from '../../models/overview/Sloa';
import { Acknowledgement } from '../../models/review-page/ReviewPage';
import { WarningOrError } from '../../models/shared/WarningOrError';
import { WireInfo } from '../../models/wire/WireInfo';
import { selectIsCreateSloaToggleFlagEnabled, selectIsEnableWiresCondensedLayout } from '../../../feature-flags/reducers';
import { selectCanRelease, selectCostBasis, selectIs401kToAccount, selectIsAchDistributionUpdatedByVerify, selectIsAchGrossNetUpdatedByVerify, selectIsBundledOneTimeTotalDist, selectJournalsUseStandingAuth, selectPendForRelease, selectPendForReleaseCustomRule, selectRevalidationStatus, selectSubmitAndCreateToggledOn, selectTemplateId, selectToAccountsInfo, selectTransactionForm, selectTransactionFormDirection, selectUseStandingAuth, selectVerifyCallFinished, selectVerifyErrorsByToAccount } from '../../../create-request/reducers';
import { positionPage } from '../../../shared/utilities/PrintPageUtils';
import {
  selectAchHasError,
  selectAchInfo,
  selectAchProcessDate,
  selectAchRecurringFrequency,
  selectAllEauthAccountHoldersHaveEmailAddress,
  selectAllSelectedEauthAccountHoldersHaveEmailAddress,
  selectAllSelectedEauthClientsAwaitingAlliance,
  selectCheckClientAuthNeeded,
  selectCheckDisplayClientAuthSection,
  selectCheckInfo,
  selectEauthModel,
  selectEditFLowFromTableComplete,
  selectInternalTransferInfo,
  selectInternalTransfersInfo,
  selectIsRecurring, selectIsSubmitAndCreate, selectItMultipleToAccountsUsed, selectItStwProcessCode,
  selectPendReasonsList,
  selectSaveAsTemplateToggledOn,
  selectShowSubmitAndCreate,
  selectStagedTransactionForm,
  selectStateAmountReview,
  selectStateCode,
  selectStateTaxPercentDefault,
  selectStateTypeInd, selectSubmitAndCreateEauthIneligible,
  selectTemplateNickname,
  selectTransactionFormServiceError, selectTransferType,
  selectWarningList,
  selectWireClientAuthNeeded,
  selectWireHasEAuthAccess,
  selectWireInfo,
  selectWireIsPendingOnlyForCTWE,
  selectRevalidationResponse
} from '../../reducers';
import { selectSetupEAuthorization } from '../../../setup-eAuthorization/reducers';
import { EAuthClient } from '../../../setup-eAuthorization/models/EAuthClients';
import { InternalTransfersInfo } from '../../models/internal-transfer/InternalTransfersInfo';
import { InitReleaseActions } from '../../../initiate-and-release/actions';
import { selectInitReleaseTransactionInContext } from '../../../initiate-and-release/reducers';
import { DraftListTableColumn } from '../../../initiate-and-release/Models/Drafts/DraftResponse';
import { Revalidation } from '../../models/shared/Revalidation';
import { mapInitiatedDraftsToTableColumn } from '../transactions-table/table-helpers';
import { Hyperlink } from '../../../shared/types/Hyperlink';
import { Router } from '@angular/router';
import { selectStandingAuthFormServiceError, selectStandingAuthItCustomRuleSplitPendForRelease, selectStandingAuthWireCustomRuleSplitPendForRelease, selectStandingAuthWireInfo } from '../../../standing-authorizations/reducers';
import { StandingAuthInternalTransferActions, StandingAuthReviewPageActions, StandingAuthWireActions } from '../../../standing-authorizations/actions';
@Component({
  standalone: false,
  selector: 'mm-review-page',
  templateUrl: './review-page.component.html',
  styleUrls: ['./review-page.component.scss']
})
export class ReviewPageComponent implements OnInit {
  @Output() deleteNewAchProfileFromReview = new EventEmitter<boolean>();

  readonly labels = transactionDetailLabels;

  accountClassifications: Classifications;
  accountInfo: AccountInfoBanner;
  achHasError: boolean;
  achInfo: AchInfo;
  acknowledgeCallFinished: boolean;
  acknowledgement: Acknowledgement;
  achUpdatedInformationBannerTitle = Constants.achUpdatedInformationBannerTitle;
  allEauthAccountHoldersHaveAnEmailAddress: boolean;
  allSelectedEauthAccountHoldersHaveAnEmailAddress: boolean;
  attentionMessageRequired: boolean = false;
  canRelease: boolean = false;
  checkClientAuthorizationNeeded: boolean;
  checkInfo: CheckInfo;
  currentDraftInContext$ = new BehaviorSubject<DraftListTableColumn | null>(null);
  defaultStateTax: string;
  deleteDraftClicked$ = new BehaviorSubject<boolean>(false);
  destroy$: Subject<boolean> = new Subject<boolean>();
  displayClientAuthorizationSection: boolean;
  draftInContext: DraftListTableColumn;
  eAuthIneligible: boolean;
  eAuthInfo: EAuthInfo;
  eAuthRestricted: boolean;
  errors: WarningOrError[];
  errorSummaryText: string = Constants.moneyMovementAcknowledgeErrorSummary;
  extraPrompts: ItExtraPrompts;
  hasAtpTimeoutError: boolean = false;
  hasBadRequestServiceError: boolean = false;
  hasError = false;
  hasError$: Observable<WarningOrError | undefined>;
  hasItEauthAccess: boolean;
  hasItVerifyError: boolean;
  hasMmInitiateAccess: boolean = false;
  hasMultipleToAccounts: boolean;
  hasServiceError: boolean = false;
  hasServiceErrorFORINRTable: boolean = false;
  hasVerifyError: boolean;
  hasWireEauthAccess: boolean;
  hasWireVerifyError: boolean;
  hyphenPipe = new RemoveHyphenFromAccountPipe();
  isAccountRestricted: boolean;
  isDemoUser: boolean;
  isEmployee: boolean;
  isInitiator: boolean = false;
  isISOCompliant: boolean;
  isOrgAccount: boolean;
  isPendForRelease: boolean = false;
  isNotInitReleaseFlowCustomRules: boolean = false;
  isQcdDistributionReason: boolean;
  isRecurring: boolean;
  isReleasor: boolean;
  isSubmitAndCreate: boolean;
  isSubmitAndCreateToggledOn: boolean;
  itClientAuthorizationNeeded: boolean;
  itCtwePending: boolean;
  itInfo: InternalTransferInfo;
  itsInfo: InternalTransfersInfo;
  moneylinkAcknowledgeError: boolean;
  multipleRevalidationError: string[] = [];
  multipleRevalidationWarning: string[] = [];
  nraIndicator: boolean;
  pageTagTransType: string;
  pendingReasonsList: string[] = [];
  positionLotsPhase2EnabledFsg: boolean = false;
  regType: string;
  hasGeneratedSplitCombinedWireLoaForSubmit: boolean = false;
  revalidationResponse: Revalidation = {
    status: '',
    errors: [],
    fieldsUpdated: []
  };
  revalidationStatusInvalid: boolean = false;
  reviewPageComponentState$: Observable<ComponentState>;
  reviewPageCopy: string = Constants.reviewPageCopy;
  reviewStateTax: string;
  serviceErrorList: string[];
  showClientAuthorization: boolean;
  showSubmitAndCreate$: Observable<boolean>;
  // Split submit-and-create wires can remain on review while the second standing-auth leg finishes.
  pendingStandingAuthWireConfirmationLoad$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  pendingStandingAuthWireConfirmationLoad: boolean = false;
  // Hold the LOA open until confirmation when the split wire leg is still settling.
  deferLoaPdfOpenUntilConfirmationPage: boolean = false;
  // Standing-auth LOA generation can depend on the second leg transfer id.
  pendingStandingAuthWireLoaGeneration: boolean = false;
  singleRevalidationError: string;
  singleRevalidationWarning: string;
  nonIsoCompliantTxnInRError: string = Constants.invalidTransactionInitiateAndRelease;
  stateCode: string = '';
  stateTypeIndicator: string = '';
  stwProcessCode: string;
  submitAndCreateEauthIneligible: boolean;
  submitClicked$: Observable<boolean>;
  toAccountInfo: ToAccountInfo;
  transactionDetails: ItTransactionDetails;
  transactionForm: TransactionForm;
  transactionFormServiceError$: Observable<TransactionFormServiceError>;
  isDuplicateDraftsConflict: boolean = false;
  transactionType: string;
  transferType: string;
  trustCommentWarningBannerText = Constants.trustCommentWarningBannerText;
  url: string = "http://www.michigan.gov/taxes";
  userInputRequired: boolean;
  useSloa$: Observable<boolean>;
  warningList: (string | WarningOrError)[];
  warningMessages: Set<string> = new Set<string>();
  warningText: string;
  wireClientAuthorizationNeeded: boolean;
  wireCtwePending: boolean;
  standingAuthWireCanRelease: boolean;
  standingAuthWireClientAuthorizationNeeded: boolean;
  standingAuthWirePendForRelease: boolean;
  standingAuthWireTransferId: string;
  wireInfo: WireInfo;
  distributionReasonUpdatedByVerify: boolean;
  grossNetUpdatedByVerify: boolean;
  isIra: boolean;
  bundledFrequency: string;
  transferDirection: string;
  isViewFromReleasor: boolean;
  multipleVerifyErrors: string[] = [];
  multipleVerifyErrorsTitleText: string = 'Please call your Service Team or try again later to submit this transaction.';
  isCheckTransaction: boolean;
  useOriginalLayout: boolean = true;
  isAchTransaction: boolean = false;
  isOneTimeTotalDist: boolean;
  isItTransaction: boolean = false;
  isChecksOneTimeTotalDist: boolean = false;
  useTestTrustDigitalToPdfFlow: boolean = false;
  newRegTypesCheck = digitalRegTypes;
  enableOptionsForCheckConservOrGuardianRegTypes: boolean = true;
  shouldButtonsBeDisabled: boolean;
  isErrorFromOneTimeCreateSloaToggleOn: boolean;
  isErrorSubmit: boolean;
  atpErrorOnSubmitToggleOnBannerTitleText: string = '';
  atpErrorOnSubmitToggleOnBannerMessage: string = '';
  userName: string = '';
  costBasisMethod: string = '';
  errorLink: Hyperlink = {
    url: '',
    text: 'Move Money',
    target: '_self',
    isActionCenterHyperLink: false
  };
  isChecksBundledOneTimeTotalDist: boolean;
  is401kToAccount: boolean;
  showCharitableContributionBannerForReleaseFlow: boolean = false;
  createSloaTransactionisPendForRelease: boolean = false;
  isCreateSloaToggleFlagEnabled: boolean = false;
  transmissionNotes: string = '';
  transmissionNotesLabel: string = this.labels.wireTransmissionNotes;

  constructor(private store: Store, private toastr: ToastrService, private featureFlagService: FeatureFlagService, private datePipe: DatePipe, private router: Router) { }

  ngOnInit(): void {
    this.store.select(selectStagedTransactionForm).pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.transactionForm = data;
      this.transactionDetails = data.transactionDetails as ItTransactionDetails;
      this.extraPrompts = data.extraPrompts as ItExtraPrompts;
      this.transactionType = data.transactionType;
      let wireTransactionDetails = data.transactionDetails as WireTransactionDetails;
      this.isISOCompliant = wireTransactionDetails.isISOCompliant;
      this.transmissionNotes = wireTransactionDetails.transmissionNotes || ''; 
    });
    this.store
      .select(selectInternalTransfersInfo)
      .pipe(takeUntil(this.destroy$))
      .subscribe((itsInfo) => {
        this.itsInfo = itsInfo;
      });
    this.store.select(selectAchRecurringFrequency).pipe(takeUntil(this.destroy$), withLatestFrom(this.store.select(selectAchProcessDate))).subscribe(([frequency, processDate]) => {
      if (frequency === 'LASTBIZ') {
        this.store.dispatch(TransactionDetailsActions.loadWithdrawalDate({ completionDate: this.datePipe.transform(processDate, 'yyyy-MM-dd') ?? '' }));
      }
    });

    // I&R flow ACH - make cashiering date call to update dates when process date has been updated during revalidation
    this.store.select(selectRevalidationResponse)
      .pipe(takeUntil(this.destroy$),
        filter(response => {
          return !!response?.status;
        }),
        withLatestFrom(this.store.select(selectAchProcessDate), this.store.select(selectAchRecurringFrequency))
      )
      .subscribe(([response, processDate, recurringFrequency]) => {
        const isACHInitReleaseFromTableFlow = this.isInitiateAndReleaseFlowFromTable
          && this.transactionType === transactionTypes.ach;
        const fetchDate_processDateUpdated = response?.status === 'updated'
          && response?.fieldsUpdated.some(fields => fields.fieldName === 'processDate');
        const fetchDate_recurringFlow = recurringFrequency === 'Last Biz Day';

        if (isACHInitReleaseFromTableFlow && (fetchDate_processDateUpdated || fetchDate_recurringFlow)) {
          this.store.dispatch(TransactionDetailsActions.loadWithdrawalDate({ completionDate: this.datePipe.transform(processDate, 'yyyy-MM-dd') ?? '' }));
        }
      });

       this.store.select(selectRevalidationResponse)
      .pipe(takeUntil(this.destroy$), 
        filter(response => {
          return !!response?.status && this.transactionType === transactionTypes.wire;
        })
      )
      .subscribe((response) => {
        const processDateUpdated = response?.fieldsUpdated?.find(field => field.fieldName === 'processDate');
        
        if (processDateUpdated) {
          this.store.dispatch(SharedActions.updateSelectedDate({ newDate: processDateUpdated.updatedValue }));
        }
    });
    
    this.store.select(selectRegType).pipe(takeUntil(this.destroy$)).subscribe(regType => { this.regType = regType; });

    this.store.select(selectIs401kToAccount).pipe(takeUntil(this.destroy$)).subscribe(is401kToAccount => {
      this.is401kToAccount = is401kToAccount;
    });

    combineLatest([
      this.store.select(selectStandingAuthWireCustomRuleSplitPendForRelease),
      this.store.select(selectStandingAuthItCustomRuleSplitPendForRelease)
    ]).pipe(takeUntil(this.destroy$)).subscribe(([wirePend, itPend]) => {
      this.createSloaTransactionisPendForRelease = wirePend || itPend;
    });

    this.store.select(selectIsCreateSloaToggleFlagEnabled).pipe(takeUntil(this.destroy$)).subscribe(flag => {
      this.isCreateSloaToggleFlagEnabled = flag
    });

    combineLatest([
      this.store.select(selectStagedTransactionForm),
      this.store.select(selectIsBundledOneTimeTotalDist),
      this.store.select(selectIsEnableWiresCondensedLayout)
    ]).pipe(takeUntil(this.destroy$)).subscribe(([form, isBundledOneTimeTotalDist, wiresCondensedFlaggedOn]) => {
      this.isCheckTransaction = form.transactionType === transactionTypes.check;
      const checkExtraPrompts = form.extraPrompts as ChecksExtraPrompts;
      this.isChecksOneTimeTotalDist = this.isCheckTransaction && checkExtraPrompts?.frequency === 'onetimeTotalDist';
      this.isChecksBundledOneTimeTotalDist = this.isCheckTransaction && isBundledOneTimeTotalDist;
      this.isAchTransaction = form.transactionType === transactionTypes.ach;
      this.isItTransaction = form.transactionType === transactionTypes.internalTransfer;
      if (this.isCheckTransaction) {
        this.useOriginalLayout = false;
      } else if (this.isAchTransaction) {
        this.useOriginalLayout = false;
      } else if (this.isWireTransaction()) {
        this.useOriginalLayout = wiresCondensedFlaggedOn ? false : true;
      } else if (this.isItTransaction && !this.isPositionsTransaction(this.extraPrompts?.transferType ?? '')) {
        this.useOriginalLayout = false;
      } else {
        this.useOriginalLayout = true;
      }
    });

    this.store.select(selectSetupEAuthorization).pipe(takeUntil(this.destroy$)).subscribe(setupEauth => {
      if (setupEauth.email.isEmailSubmitted) {
        let allClientsEligible = setupEauth.eauth.eauthClients.eauthClients.every((client: EAuthClient) => client.isEauthEligible);
        if (allClientsEligible) {
          this.submitAndCreateEauthIneligible = false;
        }
      }
    });

    this.store.select(selectHasPositionLotsPhase2).pipe(takeUntil(this.destroy$)).subscribe(val => {
      this.positionLotsPhase2EnabledFsg = val;
    });

    this.store.select(selectRevalidationResponse).pipe(takeUntil(this.destroy$)).subscribe(revalidationres => {
      this.revalidationResponse = revalidationres!;
    });

    this.store.select(selectIsIra).pipe(takeUntil(this.destroy$)).subscribe(isIra => {
      this.isIra = isIra;
    });

    this.store.select(selectTransactionFormDirection).pipe(takeUntil(this.destroy$)).subscribe(direction => {
      this.transferDirection = direction;
    });

    this.pageTagTransType = 'type:' + this.transactionType.replace('-', '');

    AdobeHelpers.trackPage('review_transaction', { 'user_selection': `${this.pageTagTransType}` });

    this.store.select(selectHasAccessInitiateMoneyMovement)
      .pipe(takeUntil(this.destroy$))
      .subscribe(response => {
        this.hasMmInitiateAccess = response;
      });

    this.useSloa$ = this.store.select(selectUseStandingAuth);
   
    //TODO: make the conditions for loading the confirmation page more consistent (possibly move relevant itInfo into reviewPage section in the store)
    // This shared post-ack subscription should only rerun when acknowledge or wire-template
    // completion state actually changes. That avoids retriggering confirmation/LOA logic on
    // unrelated review-page updates while still letting wire template flows continue.
    combineLatest([
      this.store.select(selectReviewPage),
      this.store.select(selectCreateWireTemplateCallCompleted),
      this.store.select(selectPatchWireTemplateCallCompleted)
    ]).pipe(
      takeUntil(this.destroy$),
      map(([reviewPage, createWireTemplateCallCompleted, patchWireTemplateCallCompleted]) => ({
        acknowledgeCallFinished: reviewPage.acknowledgeCallFinished,
        createWireTemplateCallCompleted,
        patchWireTemplateCallCompleted,
      })),
      distinctUntilChanged((previous, current) =>
        previous.acknowledgeCallFinished === current.acknowledgeCallFinished
        && previous.createWireTemplateCallCompleted === current.createWireTemplateCallCompleted
        && previous.patchWireTemplateCallCompleted === current.patchWireTemplateCallCompleted
      ),
      filter(({ acknowledgeCallFinished }) => acknowledgeCallFinished),
      withLatestFrom(
        this.store.select(selectAchHasError),
        this.store.select(selectAllSelectedEauthClientsAwaitingAlliance),
        this.store.select(selectSubAccountId),
        this.store.select(selectSaveAsTemplateToggledOn),
        this.store.select(selectTemplateNickname),
        this.store.select(selectTemplatesList),
        this.store.select(selectTemplateId),
        this.store.select(selectWireIsPendingOnlyForCTWE)
      ),
    ).subscribe(([templateState, achHasError, clientsAwaitingAlliance, subAccountId,
      saveAsTemplate, templateNickname, templates, templateId, isPendingForCTWE]) => {
      const { createWireTemplateCallCompleted, patchWireTemplateCallCompleted } = templateState;
      this.acknowledgeCallFinished = true;
      this.achHasError = achHasError;

      //If Acknowledge Call finished successfully, call the EmailAddress service for each customer used for eauthorization who's still Awaiting Alliance.
      if (!this.eAuthInfo?.isOptedOut) {
        clientsAwaitingAlliance.forEach(client => {
          this.store.dispatch(ReviewPageActions.clientAwaitingAllianceUsed({ accountId: subAccountId, customerId: client.customerId, emailAddress: client.emailAddress }));
        });
      }

      if (this.transactionType === transactionTypes.ach) {
        if (this.achHasError) {
          this.onEditClickedACH();
        }
        else {
          this.store.dispatch(ReviewPageActions.loadConfirmationPage());
        }
      }

      if (this.transactionType === transactionTypes.wire) {
        if (saveAsTemplate) {
          const templateInContext = templates.find(template => template.draftId === templateId);
          if (createWireTemplateCallCompleted || patchWireTemplateCallCompleted) {
            this.store.dispatch(ReviewPageActions.loadConfirmationPage());
          } else if (templateInContext && !templateInContext.draftObject?.isIsoCompliant) { //updating a non-ISO compliant wire template
            this.store.dispatch(
              WireActions.callWiresPatchTemplate({
                currentTemplate: templateInContext,
                nickname: templateNickname,
                form: this.transactionForm as WireForm
              })
            );
          } else {
            this.store.dispatch(
              WireActions.callWiresCreateTemplate({ templateNickname })
            );
          }
        } else {
          // Split submit-and-create wires only wait on a second acknowledge when the
          // standing-auth leg still needs its own completion path.
          if (this.shouldRunSplitStandingAuthWireAcknowledge()) {
            this.deferLoaPdfOpenUntilConfirmationPage = true;
            this.store.dispatch(StandingAuthWireActions.callAcknowledgeV3ForCustomRules());
            this.setPendingStandingAuthWireConfirmationLoad(true);
          } else {
            this.store.dispatch(ReviewPageActions.loadConfirmationPage());
          }
        }

        const isWireTemplateReadyForLoa = ((saveAsTemplate && createWireTemplateCallCompleted) || !saveAsTemplate);
        const shouldGenerateClientAuthWireLoa =
          this.wireClientAuthorizationNeeded &&
          (this.extraPrompts.useStandingAuth === yesNo.no || this.wireCtwePending) &&
          this.eAuthInfo.isOptedOut &&
          isWireTemplateReadyForLoa &&
          (this.isInRFirm ? this.canRelease : true);
        const shouldGenerateBundledCtweWireLoa =
          this.extraPrompts.useStandingAuth === 'bundled' &&
          isPendingForCTWE &&
          (this.isInRFirm ? this.canRelease : true);
        const shouldGenerateOneTimeWireLoa = shouldGenerateClientAuthWireLoa || shouldGenerateBundledCtweWireLoa;
        const shouldGenerateStandingAuthWireLoa = this.shouldGenerateStandingAuthWireLoa(isWireTemplateReadyForLoa);

        if (shouldGenerateOneTimeWireLoa) {
          if (this.shouldSkipSplitCombinedWireLoaGeneration(shouldGenerateOneTimeWireLoa, shouldGenerateStandingAuthWireLoa)) {
            return;
          }

          this.generateLoaPDF('review', shouldGenerateStandingAuthWireLoa);
        } else if (shouldGenerateStandingAuthWireLoa) {
          this.queueStandingAuthWireLoaGeneration();
        }
      }

      if (this.transactionType === transactionTypes.internalTransfer && !this.itInfo.hasError) {
        this.store.dispatch(ReviewPageActions.loadConfirmationPage());
        if ((this.itInfo.clientAuthorizationNeeded || this.multiAccountClientAuthorizationNeeded) &&
          (this.extraPrompts.useStandingAuth === yesNo.no || this.itCtwePending) && this.eAuthInfo.isOptedOut && (this.isInRFirm ? this.canRelease : true)) {
          // generate LOA pdf for releasor flow when the transaction has eauth access and the user has opted out of eauthorizaton
          if (this.itInfo.clientAuthorizationNeeded && !this.isPendForRelease && (this.isInitiateAndReleaseFlowFromTable ? this.hasEauthAccess : true)) {
            this.generateLoaPDF('review');
          }
          // generate LOA pdf for releasor flow when the transaction has eauth access and the user has opted out of eauthorizaton
          if (this.multiAccountClientAuthorizationNeeded && (this.isInitiateAndReleaseFlowFromTable ? this.hasEauthAccess : true)) {
            var toAccounts: string[] = [];
            for (let i = 0; i < this.itsInfo.multipleToJournalsList.length; i++) {
              let toAccountIncontext = this.itsInfo.multipleToJournalsList[i].toAccountInfo.accountNumber;
              if (!(this.itsInfo.multipleAcknowledgeListById[toAccountIncontext]?.hasError ?? false) && this.itsInfo.multipleToJournalsList[i].clientAuthorizationNeeded && ((this.isInRFirm && this.itsInfo.multipleToJournalsList[i].journalAuthResponse?.canRelease) || !this.isInRFirm)) {
                toAccounts.push(toAccountIncontext);
              }
            }
            this.generateMultipleLoaPDFs('review', toAccounts);
          }
        }
      }

      if (this.transactionType === transactionTypes.check) {
        this.store.dispatch(ReviewPageActions.loadConfirmationPage());
        if (this.checkInfo.clientAuthorizationNeeded && (this.extraPrompts.useStandingAuth === yesNo.no || this.checkInfo.isPendingForCTWE) && this.eAuthInfo.isOptedOut
          && this.eAuthInfo.isOptedOut && (this.isInRFirm ? this.canRelease : true)) {
          this.generateLoaPDF('review');
        }
      }
    });
    this.store.select(selectWireHasEAuthAccess).pipe(takeUntil(this.destroy$)).subscribe(_hasEAuthAccess => this.hasWireEauthAccess = _hasEAuthAccess);
    this.store.select(selectWireClientAuthNeeded).pipe(takeUntil(this.destroy$)).subscribe(_clientAuthNeeded => this.wireClientAuthorizationNeeded = _clientAuthNeeded);
    this.store.select(selectStandingAuthWireInfo).pipe(takeUntil(this.destroy$)).subscribe(wireInfo => {
      this.standingAuthWireCanRelease = wireInfo?.authResponse?.canRelease ?? false;
      this.standingAuthWireClientAuthorizationNeeded = wireInfo?.clientAuthorizationNeeded ?? false;
      this.standingAuthWirePendForRelease = wireInfo?.authResponse?.pendForRelease ?? false;
      this.standingAuthWireTransferId = wireInfo?.transferId ?? '';

      if (this.pendingStandingAuthWireConfirmationLoad && this.standingAuthWireTransferId) {
        this.setPendingStandingAuthWireConfirmationLoad(false);
        this.store.dispatch(ReviewPageActions.loadConfirmationPage());
      }

      if (this.pendingStandingAuthWireLoaGeneration && this.standingAuthWireTransferId) {
        this.pendingStandingAuthWireLoaGeneration = false;
        this.generateStandingAuthLoaPDF();
      }
    });
    this.store.select(selectCheckDisplayClientAuthSection).pipe(takeUntil(this.destroy$)).subscribe(_clientAuthNeeded => this.displayClientAuthorizationSection = _clientAuthNeeded);
    this.store.select(selectCheckClientAuthNeeded).pipe(takeUntil(this.destroy$)).subscribe(_clientAuthNeeded => this.checkClientAuthorizationNeeded = _clientAuthNeeded);

    this.store.select(selectInternalTransferInfo).pipe(takeUntil(this.destroy$)).subscribe(itInfo => {
      this.itInfo = itInfo;
      this.accountInfo = itInfo?.accountInfoBanner;
      this.toAccountInfo = itInfo?.toAccountInfo;
      this.hasItEauthAccess = itInfo?.eauthAccess;
      this.itClientAuthorizationNeeded = itInfo?.clientAuthorizationNeeded;
      this.itCtwePending = itInfo?.isPendingOnlyForCTWE;
    });

    this.store.select(selectJournalsUseStandingAuth).pipe(takeUntil(this.destroy$), filter(value => !!value), distinctUntilChanged(),).subscribe(value => { this.bundledFrequency = value});

    this.store.select(selectItMultipleToAccountsUsed).pipe(takeUntil(this.destroy$)).subscribe(_multipleToAccounts => this.hasMultipleToAccounts = _multipleToAccounts);

    this.store.select(selectCheckInfo).pipe(takeUntil(this.destroy$)).subscribe(checkInfo => {
      this.checkInfo = checkInfo;
      this.isQcdDistributionReason = checkInfo?.distributionReason?.subCode === RothConversion.DistributionReasons.QCD_SUB_CODE;
    });

    this.store.select(selectWireInfo).pipe(takeUntil(this.destroy$)).subscribe(wireInfo => {
      this.wireInfo = wireInfo;
      this.wireCtwePending = wireInfo?.isPendingOnlyForCTWE;
      const isIrsAba = wireInfo.isIrsAba || false;
      this.transmissionNotesLabel = isIrsAba ? this.labels.wireIrsTransmissionNotes : this.labels.wireTransmissionNotes;
    });

    this.store.select(selectPendForRelease).pipe(takeUntil(this.destroy$)).subscribe(shouldPendForRelease => {
      this.isPendForRelease = shouldPendForRelease;
    });

    this.store.select(selectPendForReleaseCustomRule).pipe(takeUntil(this.destroy$)).subscribe(noRuleReturned => {
      this.isNotInitReleaseFlowCustomRules = noRuleReturned;
    });

    this.store.select(selectCanRelease).pipe(takeUntil(this.destroy$)).subscribe(canRelease => {
      this.canRelease = canRelease;
    });

    this.store.select(selectAchInfo).pipe(takeUntil(this.destroy$)).subscribe(achInfo => {
      this.achInfo = achInfo;
    });

    this.store.select(selectTransferType).pipe(takeUntil(this.destroy$)).subscribe(type => {
      this.transferType = (typeof type === 'string') ? type : "";
    });

    this.store.select(selectStateCode).pipe(takeUntil(this.destroy$)).subscribe(stateCd => {
      this.stateCode = stateCd;
    });

    this.store.select(selectStateTypeInd).pipe(takeUntil(this.destroy$)).subscribe(stateTypeInd => {
      this.stateTypeIndicator = stateTypeInd;
    });

    this.store.select(selectStateTaxPercentDefault).pipe(takeUntil(this.destroy$)).subscribe(stateDefault => {
      this.defaultStateTax = stateDefault;
    });

    this.store.select(selectStateAmountReview).pipe(takeUntil(this.destroy$)).subscribe(reviewStateTax => {
      this.reviewStateTax = reviewStateTax;
    });

    this.store.select(selectWarningList).pipe(takeUntil(this.destroy$)).subscribe(warningList => {
      this.warningList = warningList;
    });

    this.store.select(selectPendReasonsList).pipe(takeUntil(this.destroy$)).subscribe(pendlist => {
      this.pendingReasonsList = pendlist;
    });

    this.store.select(selectIsRecurring).pipe(takeUntil(this.destroy$)).subscribe(isRecurring => {
      this.isRecurring = isRecurring;
    });

    combineLatest([
      this.store.select(selectEauthModel),
      this.store.select(selectVerifyCallFinished),
    ])
      .pipe(takeUntil(this.destroy$),
        withLatestFrom(this.store.select(selectEditFLowFromTableComplete)))
      .subscribe(([[eAuthModel, verifyCallFinished], isEditFlow]) => {
        if (!this.isInitiateAndReleaseFlowFromTable) {
          this.showClientAuthorization = ((this.extraPrompts.useStandingAuth === yesNo.no &&
            this.clientAuthorizationNeeded && this.hasEauthAccess) ||
            this.displayClientAuthorizationSection) && !isEditFlow;
        }
        // only wait for verify to finish if init release from table flow - need info from verify response
        else if (verifyCallFinished) {
          this.showClientAuthorization = ((this.extraPrompts.useStandingAuth === yesNo.no &&
            this.clientAuthorizationNeeded && this.hasEauthAccess) ||
            this.displayClientAuthorizationSection) && !isEditFlow;
            this.showCharitableContributionBannerForReleaseFlow = this.hasCharitableContributionWarning();
        }
        this.eAuthRestricted = eAuthModel.accountRestricted ||
          (!eAuthModel.eauthInd && !eAuthModel.isTransactionFromSLOAOrSLOA) ||
          (eAuthModel.eauthInd && eAuthModel.allAccountHolderIneligible);
        this.eAuthIneligible = eAuthModel.allAccountHolderIneligible;
      });

    this.store.select(selectAcknowledgement).pipe(takeUntil(this.destroy$)).subscribe(data => {
      this.acknowledgement = data;
      const acknowledgementError = this.acknowledgement.error;
      if (acknowledgementError) {
        this.hasError = !!Object.keys(acknowledgementError).length;
        this.errors = this.hasError ? [acknowledgementError] : [];
      }
      AdobeHelpers.trackClick('reviewPage_submitButton', AdobeConstants.LINKID + AdobeConstants._SUBMIT);
    });

    this.store.select(selectClassifications).pipe(takeUntil(this.destroy$)).subscribe(classifications => {
      this.accountClassifications = classifications;
    });

    this.store.select(selectInitReleaseTransactionInContext).pipe(takeUntil(this.destroy$)).subscribe(value => {
      this.draftInContext = mapInitiatedDraftsToTableColumn(value);
      this.currentDraftInContext$.next(this.draftInContext);
    });

    this.transactionFormServiceError$ = this.store.select(selectTransactionFormServiceError);
    this.transactionFormServiceError$.pipe(takeUntil(this.destroy$)).subscribe(val => {
      this.isErrorFromOneTimeCreateSloaToggleOn = false;
      this.isErrorSubmit = false;
      
      const hasConflictStatus = val.status === HttpStatusCode.Conflict;
      // Check for "already released" error in both message field and errorList array
      const hasAlreadyReleasedError = val.message === Constants.initReleaseAlreadyReleasedError || 
        val.errorList?.some(err => err.detail === Constants.initReleaseAlreadyReleasedError);
      
      if (hasConflictStatus || hasAlreadyReleasedError) {
        combineLatest([
          of(this.isInitiateAndReleaseFlowFromTable)
        ]).pipe(
          takeUntil(this.destroy$),
        ).subscribe(([isInitiateAndReleaseFlow]) => {
          this.isDuplicateDraftsConflict = isInitiateAndReleaseFlow;
          
          if (this.isDuplicateDraftsConflict) {
            // Only show toaster for conflict status
            if (hasConflictStatus) {
              this.toastr.error(Constants.initiateAndReleaseDuplicateDraftError, '', { toastClass: 'ngx-toastr toast-error tall-toastr' });
            }
            // Disable buttons when conflict or already released
            // if this logic is updated and change affects wires, will also need to update the Edit link in transaction-details-wire-condensed.component.ts
            this.shouldButtonsBeDisabled = true;
          }
        });
      }
      else {
        // If no conflict, reset draft conflict flag
        this.isDuplicateDraftsConflict = false;
      }

      if (val?.status === HttpStatusCode.BadRequest) {
        this.hasBadRequestServiceError = true;
        this.hasServiceErrorFORINRTable = val.hasError && this.isInitReleaseFlowFromTableVerifyFailure(val.name);
        this.scrollTo();
        if (val.errorList) {
          this.serviceErrorList = val.errorList.map((err) => !!err.detail ? err.detail : err.title);
          if (this.serviceErrorList.includes(Constants.transactionFailedButTweSubmitted)) {
            this.toastr.error(Constants.transactionFailedButTweSubmitted, '', { toastClass: 'ngx-toastr toast-error tall-toastr' });
          }
        }
        this.hasWireVerifyError = val.hasError && val.name == ApiEndpointType.wireVerifyV3;
        this.hasItVerifyError = val.hasError && val.name == ApiEndpointType.internalTransferVerify;
      }
      else if (val.errorList && val.errorList.map((err) => err.detail).includes(Constants.atpRequestTimeoutErrorDetail)) {
        this.hasAtpTimeoutError = true;
        this.scrollTo();
        this.serviceErrorList = this.isInitiateAndReleaseFlowFromTable ? [Constants.atpRequestTimeoutErrorMessageInR] : [Constants.atpRequestTimeoutErrorMessage];
      }
      else if (val.errorList &&
        (val.errorList.map((err) => err.detail).includes(Constants.atpRequestSloaFailedToggleOnSubmit) ||
          val.errorList.map((err) => err.detail).includes(Constants.atpRequestOneTimeFailedToggleOnSubmit))) {
        this.hasAtpTimeoutError = true;
        this.isErrorFromOneTimeCreateSloaToggleOn = true;
        this.isErrorSubmit = true;
        this.scrollTo();
        this.atpErrorOnSubmitToggleOnBannerTitleText = Constants.atpErrorOnSubmitToggleOnBannerTitleText;
        this.atpErrorOnSubmitToggleOnBannerMessage = Constants.atpErrorOnSubmitToggleOnBannerMessage;
        this.serviceErrorList = [Constants.atpRequestSloaFailedToggleOnSubmit];
      }
      else {
        this.hasServiceErrorFORINRTable = val.hasError && this.isInitReleaseFlowFromTableVerifyFailure(val.name);
        this.hasServiceError = val.hasError;
        this.hasWireVerifyError = this.hasServiceError && val.name == ApiEndpointType.wireVerifyV3;
        this.hasItVerifyError = val.hasError && val.name == ApiEndpointType.internalTransferVerify;
        this.scrollTo();
        this.hasBadRequestServiceError = false;
        this.hasAtpTimeoutError = false;
      }

      // If the split standing-auth acknowledge fails while review is waiting on that
      // second leg, recover from the main transaction-form error source by clearing
      // the pending state and continuing to confirmation instead of staying stuck.
      if (this.pendingStandingAuthWireConfirmationLoad
        && val.hasError
        && val.name == ApiEndpointType.wireAcknowledgeV3) {
        this.setPendingStandingAuthWireConfirmationLoad(false);
        this.store.dispatch(ReviewPageActions.loadConfirmationPage());
      }
    });

    this.store.select(selectStandingAuthFormServiceError).pipe(takeUntil(this.destroy$)).subscribe(val => {
      // Apply the same recovery when the split standing-auth acknowledge failure is
      // reported through the standing-auth form error source instead of the main one.
      if (this.pendingStandingAuthWireConfirmationLoad
        && val.hasError
        && val.name == ApiEndpointType.wireAcknowledgeV3) {
        this.setPendingStandingAuthWireConfirmationLoad(false);
        this.store.dispatch(ReviewPageActions.loadConfirmationPage());
      }
    });

    this.store.select(selectVerifyErrorsByToAccount).pipe(takeUntil(this.destroy$)).subscribe(multipleVerifyErrors => {
      this.multipleVerifyErrors = multipleVerifyErrors;

      // Check if any error contains the position shift message and update title accordingly
      const positionError = multipleVerifyErrors.find(error => 
        error.includes('has shifted order due to recent account activity')
      );
      
      if (positionError) {
        const positionName = positionError.match(/Position '([^']+)'/)?.[1]?.replace(/\s+/g, ' ').trim() ?? '';
        this.multipleVerifyErrorsTitleText = `Cannot release position '${positionName}'.`;
      } else {
        this.multipleVerifyErrorsTitleText = 'Please call your Service Team or try again later to submit this transaction.';
      }
      
      if (multipleVerifyErrors.length > 0) {
        this.scrollTo();
      }
    });

    this.hasError$ = this.store.pipe(
      select(selectAcknowledgementError)
    );

    this.submitClicked$ = this.store.pipe(
      select(selectReviewPageSubmitClicked)
    );

    if (this.transactionType === transactionTypes.ach) {
      this.reviewPageCopy = `${this.reviewPageCopy}`;
    }
    this.store.select(selectCostBasis).pipe(takeUntil(this.destroy$)).subscribe(info => this.costBasisMethod = info ?? '');

    this.store
      .select(selectCancelModalContinueClickedTransactionReviewPage)
      .pipe(
        takeUntil(this.destroy$),
        filter(continueClicked => continueClicked)
      )
      .subscribe(_ => {
        this.processNewProfileCancellation(true);
        this.store.dispatch(ReviewPageActions.cancelClicked());
        if (this.hasMmInitiateAccess) {
          this.store.dispatch(resetCancelModal());
        }
      });

    this.store.select(selectCancelModalContinueClickedForEditTweReviewPage).pipe(takeUntil(this.destroy$)).subscribe(continueClicked => {
      if (continueClicked) {
        this.processNewProfileCancellation(true);
        this.store.dispatch(ReviewPageActions.cancelClicked());
      }
    });

    this.store.select(selectPdf).pipe(takeUntil(this.destroy$)).subscribe(data => {
      if (data && !this.deferLoaPdfOpenUntilConfirmationPage) {
        let buffer = getArrayBufferFromBase64(data);
        let pdf = new Blob([buffer], { type: 'application/pdf' });
        openPdfInNewWindow(pdf, false);
      }
    });

    this.store.select(selectEAuthInfo).pipe(takeUntil(this.destroy$)).subscribe(eAuthInfo => {
      this.eAuthInfo = eAuthInfo;
    });

    this.store.select(selectNraIndicator).pipe(takeUntil(this.destroy$)).subscribe(nraIndicator => {
      this.nraIndicator = nraIndicator ?? false;
    });

    this.store.select(selectItStwProcessCode).subscribe(value => {
      this.stwProcessCode = value;
    });

    this.store.select(selectIsEmployee).subscribe(value => {
      this.isEmployee = value;
    });

    this.store.select(selectIsDemoUser).subscribe(value => {
      this.isDemoUser = value;
    });

    this.store.select(selectIsUserInputRequired).subscribe(value => {
      this.userInputRequired = value;
    });

    this.store.select(selectRevalidationStatus).subscribe(status => {
      this.revalidationStatusInvalid = status === 'invalid';
    });

    this.store.select(selectStagedTransactionForm).pipe(takeUntil(this.destroy$)).subscribe((val) => {
      this.isOneTimeTotalDist = isItExtraPrompts(val.extraPrompts) && val.extraPrompts.frequency === "onetimeTotalDist";
    });

    this.store.select(selectIsAchDistributionUpdatedByVerify).pipe(takeUntil(this.destroy$)).subscribe(distributionReasonUpdatedByVerify => {
      this.distributionReasonUpdatedByVerify = distributionReasonUpdatedByVerify;
    });

    this.store.select(selectIsAchGrossNetUpdatedByVerify).pipe(takeUntil(this.destroy$)).subscribe(grossNetUpdatedByVerify => {
      this.grossNetUpdatedByVerify = grossNetUpdatedByVerify;
    });

    combineLatest([
      this.store.select(selectInitReleaseTransactionInContext),
      this.store.select(selectUsername),
      this.store.select(selectHasAccessReleaseMoneyMovement)
    ]).pipe(takeUntil(this.destroy$)).subscribe(([txnInContext, userName, hasReleaseAccess]) => {
      this.isInitiator = ((txnInContext.createdByLoginId === userName) && userName !== '') || ((txnInContext.createdByLoginId !== '' && !hasReleaseAccess));
      this.isReleasor = hasReleaseAccess;
      this.userName = userName;
      this.isViewFromReleasor = (txnInContext.createdByLoginId === userName && userName !== '' && txnInContext.createdByLoginId !== '');
    });


    // Scroll to top of the page on page load
    this.scrollTo();

    this.reviewPageComponentState$ = combineLatest([
      this.store.select(selectReviewPage),
      this.pendingStandingAuthWireConfirmationLoad$
    ]).pipe(
      map(([reviewPage, pendingStandingAuthWireConfirmationLoad]) => ({
        ...reviewPage,
        loading: reviewPage.loading || pendingStandingAuthWireConfirmationLoad,
      }))
    );

    this.attentionMessageRequired = this.setWarningMessagesForVerification();

    this.showSubmitAndCreate$ = this.store.select(selectShowSubmitAndCreate);

    this.store.select(selectAllSelectedEauthAccountHoldersHaveEmailAddress).pipe(takeUntil(this.destroy$))
      .subscribe(val => this.allSelectedEauthAccountHoldersHaveAnEmailAddress = val);

    this.store.select(selectAllEauthAccountHoldersHaveEmailAddress).pipe(takeUntil(this.destroy$))
      .subscribe(val => this.allEauthAccountHoldersHaveAnEmailAddress = val);

    this.store.select(selectIsSubmitAndCreate).pipe(takeUntil(this.destroy$))
      .subscribe(val => this.isSubmitAndCreate = val);

    this.store.select(selectSubmitAndCreateEauthIneligible).pipe(takeUntil(this.destroy$))
      .subscribe(eauthIneligible => this.submitAndCreateEauthIneligible = eauthIneligible);

    this.store.select(selectUseTestTrustDigitalToPdfFlow).pipe(takeUntil(this.destroy$)).subscribe((val) => {
      this.useTestTrustDigitalToPdfFlow = val;
    });

    this.store.select(selectIsOrgAccount).pipe(takeUntil(this.destroy$))
      .subscribe(isOrgAccount => this.isOrgAccount = isOrgAccount);

    this.store.select(selectAchInfo).pipe(takeUntil(this.destroy$),filter(achInfo => !!achInfo?.cashieringRequestId),take(1)).subscribe(() => {
      if (this.isNewOnRequestAchProfileCreated() && !this.displayRevalidationError) {
        this.toastr.success(Constants.newOnRequestProfileCreated);
      }
    });

    this.store
      .select(selectCreateWireTemplateCallCompleted)
      .pipe(
        takeUntil(this.destroy$),
        withLatestFrom(
          this.store.select(selectCreateWireTemplateCallSuccessful),
        ),
        filter(([completed, _successful]) => completed)
      )
      .subscribe(([_completed, successful]) => {
        if (successful){
          this.toastr.success("Saved as a template");
        } else {
          this.toastr.error("Failed to save as a template");
        }
      });

    if (this.isCreateSloaToggleFlagEnabled && !this.isInitiateAndReleaseFlowFromTable) {
      this.resetStandingAuthWireForCustomRules();
      this.store.select(selectSaveAsTemplateToggledOn).pipe(takeUntil(this.destroy$)).subscribe(value => {
        if (value) {
          this.resetStandingAuthWireForCustomRules();
        }
      });
    }
  }

  // Add functionality to handle Cancel Transaction on the Review page. Should make correct drafts-api call 
  onCancelClicked(): void {
    if (this.isInitiateAndReleaseFlowFromTable && (this.router?.url?.includes('initiate-and-release'))) {
      this.deleteDraftClicked$.next(true);
    }
    else {
      this.store.dispatch(displayCancelModal({
        nextUrlState: this.isInitiateAndReleaseFlowFromTable ? navRouteConstants.initiateAndRelease : navRouteConstants.createTransaction,
        title: 'Cancel transaction in progress',
        content: ['Canceling will reset your transaction inputs. Are you sure you want to continue?'],
        greenButton: 'Cancel transaction',
        grayButton: 'Back',
        isQuicklinksNav: false,
        source: 'transactionReviewPage'
      }));
    }
  }

  resetStandingAuthWireForCustomRules() {
    this.store.select(selectStandingAuthWireInfo).pipe(take(1)).subscribe(state => {
      this.store.dispatch(StandingAuthWireActions.clearStandingAuthWireAuthResponse({ state }));
    });
    this.store.dispatch(StandingAuthInternalTransferActions.clearStandingAuthInternalTransferResponse());
  }

  get showAuthorizationDetails() {
    let isSloaOrBundledSloa = this.extraPrompts?.useStandingAuth === 'yes' || this.extraPrompts?.useBundledStandingAuth === 'yes';
    if (this.transactionType === 'check' && isSloaOrBundledSloa && (this.isChecksOneTimeTotalDist || this.isChecksBundledOneTimeTotalDist)) {
      return false;
    } else {
      return (this.showClientAuthorization || this.isOneTimeTotalDist || this.is401kToAccount)
    }
  }

  onEditClicked(): void {
    this.store.dispatch(ReviewPageActions.clearAttentionMessage());
    AdobeHelpers.fireClick(AdobeConstants.LINKID + AdobeConstants._EDIT);
    this.store.dispatch(ReviewPageActions.editClicked());

    this.processNewProfileCancellation(true);
    let acknowledgement: Acknowledgement = {
      isAcknowledgementReviewed: false,
      acknowledgementConsentTime: ""
    };
    this.store.dispatch(ReviewPageActions.updateAcknowledgement({ acknowledgement }));
  }

  onEditClickedACH(): void {
    AdobeHelpers.fireClick(AdobeConstants.LINKID + AdobeConstants._EDIT);
    this.store.dispatch(ReviewPageActions.editClicked());
    this.processNewProfileCancellation(true);
  }


  onBackButtonClicked(): void {
    this.store.dispatch(ReviewPageActions.clearAttentionMessage());
    this.store.dispatch(InitReleaseActions.backButtonClicked());
    this.store.dispatch(resetCancelModalforInitiateAndReleaseTable());
    let acknowledgement: Acknowledgement = {
      isAcknowledgementReviewed: false,
      acknowledgementConsentTime: ""
    };
    this.store.dispatch(ReviewPageActions.updateAcknowledgement({ acknowledgement }));
  }

  onSubmitAndCreatePDF(): void {
    this.hasGeneratedSplitCombinedWireLoaForSubmit = false;
    this.store.dispatch(ReviewPageActions.submitClicked());
    const isCondensedWireCreatePdfFlow = this.isWireTransaction() && !this.useOriginalLayout;
    if (!this.acknowledgement.isAcknowledgementReviewed) {
      this.showAcknowledgementReviewError();
    } else if (this.isInternalTransferWithMultipleAccounts()) {
      this.store.dispatch(ReviewPageActions.loadConfirmationPageWithoutAcknowledgeCall({ isCondensedWireCreatePdfFlow }));
      var toAccounts: string[] = [];
      this.store.select(selectToAccountsInfo).pipe(takeUntil(this.destroy$)).subscribe(toAccountInfo => {
        toAccounts = Object.keys(toAccountInfo);
      });
      this.generateMultipleLoaPDFs('review', toAccounts);
    } else {
      this.store.dispatch(ReviewPageActions.loadConfirmationPageWithoutAcknowledgeCall({ isCondensedWireCreatePdfFlow }));
      this.generateLoaPDF('review');
    }
  }

  generateLoaPDF(source: PageTypes, includeCreateSloaDetails?: boolean) {
    this.store.dispatch(EAuthActions.generateLoaPdf());
    this.store.dispatch(
      ReviewPageActions.generateAuthorizationForm({ source: source, includeCreateSloaDetails })
    );
  }

  generateStandingAuthLoaPDF() {
    this.store.dispatch(EAuthActions.generateLoaPdf());
    this.store.dispatch(StandingAuthReviewPageActions.generateAuthorizationForm());
  }

  queueStandingAuthWireLoaGeneration() {
    if (this.standingAuthWireTransferId) {
      this.generateStandingAuthLoaPDF();
      return;
    }

    this.pendingStandingAuthWireLoaGeneration = true;
  }

  generateMultipleLoaPDFs(source: PageTypes, toAccounts: string[]) {
    this.store.dispatch(EAuthActions.generateLoaPdf());
    this.store.dispatch(
      ReviewPageActions.generateMultipleAuthorizationForms({ source: source, toAccounts: toAccounts })
    );
  }

  private setPendingStandingAuthWireConfirmationLoad(isPending: boolean): void {
    this.pendingStandingAuthWireConfirmationLoad = isPending;
    this.pendingStandingAuthWireConfirmationLoad$.next(isPending);
  }

  private shouldGenerateStandingAuthWireLoa(isWireTemplateReadyForLoa: boolean): boolean {
    return this.isCreateSloaToggleFlagEnabled
      && this.isSubmitAndCreate
      && this.isInRFirm
      && this.standingAuthWireClientAuthorizationNeeded
      && this.eAuthInfo.isOptedOut
      && isWireTemplateReadyForLoa
      && !this.standingAuthWirePendForRelease
      && this.standingAuthWireCanRelease;
  }

  // Decide whether the standing-auth leg needs its own acknowledge call or can
  // complete through the main wire acknowledge flow.
  private shouldRunSplitStandingAuthWireAcknowledge(): boolean {
    return this.isCreateSloaToggleFlagEnabled
      && this.isSubmitAndCreate
      && this.isInRFirm
      && !this.shouldUseMainWireAcknowledgeFlowForSplitCustomRules();
  }

  // When both the main wire and standing-auth leg can release, keep the existing
  // single-acknowledge behavior by sending one request with both sets id.
  private shouldUseMainWireAcknowledgeFlowForSplitCustomRules(): boolean {
    return !this.isPendForRelease
      && this.canRelease
      && !this.standingAuthWirePendForRelease
      && this.standingAuthWireCanRelease;
  }

  // Skip generating an additional LOA for this submit when the one-time wire and
  // standing-auth wire LOAs will be combined into a single PDF. When both legs can
  // release, that combined document should only be generated once.
  private shouldSkipSplitCombinedWireLoaGeneration(
    shouldGenerateOneTimeWireLoa: boolean,
    shouldGenerateStandingAuthWireLoa: boolean
  ): boolean {
    const shouldGenerateSplitCombinedWireLoa =
      shouldGenerateOneTimeWireLoa
      && shouldGenerateStandingAuthWireLoa
      && this.isCreateSloaToggleFlagEnabled
      && this.isSubmitAndCreate
      && this.isInRFirm;

    if (!shouldGenerateSplitCombinedWireLoa) {
      return false;
    }

    if (this.hasGeneratedSplitCombinedWireLoaForSubmit) {
      return true;
    }

    this.hasGeneratedSplitCombinedWireLoaForSubmit = true;
    return false;
  }

  onSubmit(): void {
      this.hasGeneratedSplitCombinedWireLoaForSubmit = false;
      if (this.isEmployee) {
        this.toastr.error(Constants.toastrMessageEmployee);
        return;
      }
      if (this.isDemoUser) {
        this.toastr.error(Constants.toastrMessageDemoUser);
        return;
      }
      if (!this.userInputRequired && !this.isInitiateAndReleaseFlowFromTable) {
        this.store.dispatch(EAuthActions.optOut());
      }
      else if (!this.eAuthInfo.isOptedOut) {
        if (!this.eAuthInfo.isAccountHolderSelected) {
          this.store.dispatch(EAuthActions.invalidSubmitClick());
          this.scrollTo('client-authorization-section');
          return;
        }
        else if (!this.allSelectedEauthAccountHoldersHaveAnEmailAddress ||
          this.isSubmitAndCreate && !this.isOrgAccount && !this.regType.includes("Liv Trust") && !this.allEauthAccountHoldersHaveAnEmailAddress) {
          this.store.dispatch(EAuthActions.missingEmailAddressSubmitClick());
          return;
        }
        else if (this.isSubmitAndCreate && this.submitAndCreateEauthIneligible && !this.regType.includes("Liv Trust")) {
          return;
        }
      }

    this.store.dispatch(ReviewPageActions.submitClicked());
    if (!this.acknowledgement.isAcknowledgementReviewed) {
      this.showAcknowledgementReviewError();
    } else {
      this.submitTransaction();
    }
  }

  private submitTransaction() {
    switch (this.transactionForm.transactionType) {
      case transactionTypes.ach:
        if (this.isAddAchProfile) {
          this.store.dispatch(AchActions.callAddProfileAcknowledge());
        } else {
          this.store.dispatch(AchActions.callAcknowledge());
        }
        break;
      case transactionTypes.internalTransfer:
        if (this.isJournalAcknowledgementCall) {
          this.store.dispatch(InternalTransferActions.callAcknowledge());
        } else {
          this.store.dispatch(
            InternalTransfersActions.callAcknowledgeList()
          );
        }
        break;
      case transactionTypes.wire:
        // Set button state - duplicate drafts conflict takes precedence
        this.shouldButtonsBeDisabled = this.isDuplicateDraftsConflict;
        this.store.dispatch(WireActions.callAcknowledgeV3());
        this.store.select(selectTransactionForm).pipe(takeUntil(this.destroy$)).subscribe(wireInfo => {
          // Only update button state if no duplicate draft conflict 
          if (!this.isDuplicateDraftsConflict) {
            this.shouldButtonsBeDisabled = (wireInfo.acknowledgeCallV3Failed ?? false) && this.isErrorSubmit;
          }
        });
        break;
      case transactionTypes.check:
        if (this.isRecurring) {
          this.store.dispatch(CheckActions.callRecurringAcknowledge());
          break;
        } else {
          this.store.dispatch(CheckActions.callOnetimeAcknowledge());
          break;
        }
    }
  }

  showAcknowledgementReviewError(): void {
    let acknowledgement: Acknowledgement = {
      isAcknowledgementReviewed: this.acknowledgement.isAcknowledgementReviewed,
      error: moneyMovementAcknowledgeError,
      acknowledgementConsentTime: ""
    };
    this.store.dispatch(ReviewPageActions.updateAcknowledgement({ acknowledgement }));
    this.scrollTo();
  }

  isPositionsTransaction(transferType: string): boolean {
    return transferType === transferTypes.POSITIONS || transferType === transferTypes.POSITIONS_CASH;
  }

  scrollTo(elemName?: string) {
    const elementName = elemName ?? 'review-page-header';
    const elem = document.getElementById(elementName);
    setTimeout(function () {
      elem?.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'start' });
    }, 0);
  }

  setWarningMessagesForVerification(): boolean {
    if (this.hasWarningsOrAttentionMessages() || this.clientAuthorizationNeeded) {
      this.addClientAuthorizationWarnings();
      this.addCashieringAttentionMessages();
    }

    this.addAchAttentionMessages();

    return this.hasWarningMessages();
  }

  private hasWarningsOrAttentionMessages(): boolean {
    return Boolean(this.warningList?.length || this.achInfo?.attentionMessageList?.length);
  }

  private addClientAuthorizationWarnings(): void {
    const clientAuthWarnings = [
      prettierWarnings.clientAuth,
      prettierWarnings.electronicAuth,
      prettierWarnings.clientAuthTax,
      prettierWarnings.clientAuthNDFALPFA,
      prettierWarnings.clientAuthNonTax
    ];

    this.pendingReasonsList?.forEach(reason => {
      //Hide Client Auth message when pend reason is NDFA/LPFA and BSLOA is selected as 'bundled' for check transactions
      let skipBsloaNdFaLpfaClientAuthMessage = reason === prettierWarnings.clientAuthNDFALPFA && this.extraPrompts?.useStandingAuth === 'bundled' && this.transactionType === transactionTypes.check;

      if (clientAuthWarnings.includes(reason) && !skipBsloaNdFaLpfaClientAuthMessage) {
        this.warningMessages.add(Constants.clientAuthSignatureForm);
      }
    });
  }

  private addCashieringAttentionMessages(): void {
    if (this.isWireTransaction()) {
      this.addAllWarnings();
    } else if (this.isInternalTransferWithMultipleAccounts() && this.isPositionsTransaction(this.transferType)) {
      this.addInternalTransferWarnings();
    } else {
      this.addAllWarningMessages();
    }
  }

  public isWireTransaction(): boolean {
    return this.transactionForm?.transactionType === transactionTypes.wire;
  }

  public isInternalTransferWithMultipleAccounts(): boolean {
    return this.transactionForm?.transactionType === transactionTypes.internalTransfer && this.isPositionsTransaction(this.transferType) && this.hasMultipleToAccountsAccess;
  }

  public showMultipleToAccounts(): boolean {
    return this.hasMultipleToAccountsAccess && this.isPositionsTransaction(this.transferType) && this.isOneTimeTotalDist ? this.costBasisMethod !== undefined : true;
  }

  private addAllWarnings(): void {
    this.warningList?.forEach(warning => this.warningMessages.add(warning as string));
  }

  private addInternalTransferWarnings(): void {
    this.store.select(selectInternalTransfersInfo)
      .pipe(takeUntil(this.destroy$))
      .subscribe(itsInfo => {
        const accountInfo = itsInfo.multipleToJournalsList;
        const messageMap: Record<string, { messageId: string, messageText: string, accountNumbers: string[]; }> = {};

        accountInfo.forEach(account => {
          const { toAccountInfo, messageInfo } = account;
          const accountNumber = toAccountInfo.accountNumber;

          messageInfo.warningList.forEach((warning: WarningOrError) => {
            const { messageId, messageText } = warning;

            if (messageMap[messageId]) {
              messageMap[messageId].accountNumbers.push(accountNumber);
            } else {
              messageMap[messageId] = {
                messageId,
                messageText,
                accountNumbers: [accountNumber]
              };
            }
          });
        });

        const warningUpdates: Record<string, string> = {
          '9812': Constants.openOrdersMessage,
          '8313': Constants.securityFundsAlertMessage,
          '9851': Constants.marginLoanDisbursement,
          '9852': Constants.marginLoanDisbursement,
          '9151': Constants.earlySimpleIra
        };

        const removableWarnings = new Set(['8345', '9419']);
        const atpWarningMesssageIds = new Set(['9812', '8313', '9851', '9852', '9151']);

        Object.values(messageMap).forEach(warning => {
          const warningText = atpWarningMesssageIds.has(warning.messageId)
            ? warningUpdates[warning.messageId]
            : warning.messageText;

          const formattedMessage = `${warningText}: ${warning.accountNumbers.join(", ")}`;

          if (!removableWarnings.has(warning.messageId)) {
            this.warningMessages.add(formattedMessage);
          } else {
            this.warningMessages.delete(formattedMessage);
          }
        });
      });
  }

  private addAllWarningMessages(): void {
    const removableWarnings = new Set(['8345', '6037']);
    (this.warningList as WarningOrError[])?.forEach(warning => {
      if (removableWarnings.has(warning.messageId)) {
        this.warningMessages.delete(warning.messageText);
      } else {
        this.warningMessages.add(warning.messageText);
      }
    });
  }

  private addAchAttentionMessages(): void {
    this.achInfo?.attentionMessageList?.forEach(message => {
      if (message) this.warningMessages.add(message);
    });
  }

  private hasWarningMessages(): boolean {
    return this.warningMessages.size > 0 || this.hasCharitableContributionWarning();
  }
  
  hasCharitableContributionWarning(): boolean {
    return this.transactionType === transactionTypes.internalTransfer && (this.extraPrompts?.frequency === "onetime" || (this.extraPrompts?.useStandingAuth?.toLowerCase() === 'yes' && this.extraPrompts?.frequency?.toLowerCase() === 'recurring') || (this.bundledFrequency === 'bundled-no' || this.bundledFrequency === 'bundled-recurring')) && this.isCharitableContribution();
  }
 
  isStateTaxAttentionRequiredCT(): boolean {
    if (this.isQcdDistributionReason) {
      return false;
    }
    let isSpecial = ((this.stateTypeIndicator === stateTypeIndicators.Special) && (this.stateCode === stateCodes.CONNECTICUT) && this.reviewStateTax === '0%');
    if (this.defaultStateTax !== "0" && isSpecial) {
      return true;
    }
    return false;
  }

  isStateTaxAttentionRequiredMN(): boolean {
    if (this.isQcdDistributionReason) {
      return false;
    }
    let isSpecial = ((this.stateTypeIndicator === stateTypeIndicators.Special) && (this.stateCode === stateCodes.MINNESOTA) && this.reviewStateTax === '0%');
    if (this.defaultStateTax !== "0" && isSpecial && !this.featureFlagService.featureFlags.enableSpecialStateTax) {
      return true;
    }
    return false;
  }

  isStateTaxAttentionRequiredMI(): boolean {
    if (this.isQcdDistributionReason) {
      return false;
    }
    let isSpecial = ((this.stateTypeIndicator === stateTypeIndicators.Special) && (this.stateCode === stateCodes.MICHIGAN) && this.reviewStateTax === '0%');
    if (this.defaultStateTax !== "0" && isSpecial && !this.featureFlagService.featureFlags.enableSpecialStateTax) {
      return true;
    }
    return false;
  }

  isCharitableContribution(): boolean {
    // Check if any toAccountInfo in multipleToJournalsList has productCode "CHGFT" and registrationType "DASCG"
    if(this.itsInfo?.multipleToJournalsList.length > 0) {
    if (this.itsInfo?.multipleToJournalsList?.some(
      journal =>
        journal.toAccountInfo?.productCode === "CHGFT" &&
        journal.toAccountInfo?.registrationType === "DASCG"
      )
    ) {
      return true;
    }
  } else { 
      if (this.toAccountInfo?.productCode === "CHGFT" &&
          this.toAccountInfo?.registrationType === "DASCG"
      ) {
        return true;
      }
    }
    return false;
  }

  get isInitiateAndReleaseFlowFromTable(): boolean {
    return this.hasMmInitiateAccess && !!(this.draftInContext?.DraftId);
  }

  get hideSaveTemplate(): boolean {
    if (this.isNonIsoCompliantTransactionReleasorFlow) return true;
    if (this.isReleasor) return !!this.isViewFromReleasor;
    return this.isInitiateAndReleaseFlowFromTable && (this.hasMmInitiateAccess && !this.isReleasor);
  }

  get isInRFirm(): boolean {
    return this.hasMmInitiateAccess;
  }

  get submitButtonVerbiage(): string {
    if (this.isInitiateAndReleaseFlowFromTable && this.canRelease) return 'Release for Processing';
    if (this.isPendForRelease) return 'Submit for Review';
    if (this.createSloaTransactionisPendForRelease && !this.isInitiateAndReleaseFlowFromTable && this.isCreateSloaToggleFlagEnabled && this.hasMmInitiateAccess) return 'Submit for Review';
    return 'Submit';
  }

  isNewOnRequestAchProfileCreated(): boolean {
    if (this.transactionForm.transactionType !== transactionTypes.ach) {
      return false;
    }
    let isNewProfile = true;
    this.store.select(selectAchInstructions).pipe(takeUntil(this.destroy$)).subscribe((achInstructions) => {
      if (achInstructions?.length > 0) {
        isNewProfile = !achInstructions.some(
          (instruction) =>
            instruction.cashieringRqstId === this.achInfo.cashieringRequestId
        );
      }
      else {
        isNewProfile = false;
      }
    });
    return isNewProfile;
  }

  getAchProfileToCancel(): Sloa {
    let masterAccount: string = '';
    this.store.select(selectMasterAccount).pipe(takeUntil(this.destroy$)).subscribe(account => {
      masterAccount = account;
    });

    let profileDetails = {
      cashieringRqstId: this.achInfo?.cashieringRequestId,
      cashieringRqstSecondId: '0',
      faMasterAcct: masterAccount,
      mediaTypeCd: MediaTypeCode.A
    } as Sloa;

    return profileDetails;
  }

  get hasMultipleToAccountsAccess(): boolean {
    return this.featureFlagService.featureFlags.positionLotsPhase2Enabled || this.positionLotsPhase2EnabledFsg;
  }

  get hasMultipleToAccountsAndAccess(): boolean {
    return this.hasMultipleToAccountsAccess && this.hasMultipleToAccounts;
  }
  get isJournalAcknowledgementCall(): boolean {
    return (!this.hasMultipleToAccountsAccess || this.isRecurring || this.transferType === transferTypes.CASH);
  }

  processNewProfileCancellation(checkIfCancelSucceeds: boolean): void {
    if (this.isNewOnRequestAchProfileCreated()) {
      this.store.dispatch(deleteTransactionClicked({ transaction: this.getAchProfileToCancel(), shouldRetry: true, isNewAchProfile: true }));
      this.deleteNewAchProfileFromReview.emit(checkIfCancelSucceeds);
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  downloadPdf(): void {
    setTimeout(() => {
      let temp = document.title;
      document.title = 'Move Money - Schwab Advisor Center';
      try {
        positionPage('print-review-page');
        if (!document.execCommand('print', false, '')) {
          window.print();
        }
      } catch {
        positionPage('print-review-page');
        window.print();
      }
      document.title = temp;
    }, 10);
  }

  get displayWarning() {
    let isAgeRelevantToDistributionSelection =
      this.itInfo.iraFields.distributionReason.subCode ===
      RothConversion.DistributionReasons.CONVERSION_SUB_CODE &&
      this.itInfo.iraFields.distributionReason.code.trim() ===
      RothConversion.DistributionReasons.UNDER_59_AND_A_HALF_CONVERSION_CODE;

    let over59SelectionPossible =
      this.itInfo.iraFields.distributionReason.subCode ===
      RothConversion.DistributionReasons.CONVERSION_SUB_CODE &&
      this.itInfo.iraFields.distributionReason.code.trim() ===
      RothConversion.DistributionReasons.OVER_59_AND_A_HALF_CONVERSION_CODE;


    if (over59SelectionPossible || (isAgeRelevantToDistributionSelection && !this.accountClassifications.isCustomer59OrOlder)) {
      this.warningText = RothWarnings.verifyPageRothWarning;
      return true;
    } else {
      return false;
    }
  }

  get displayRevalidationWarning() {
    if (this.revalidationResponse?.fieldsUpdated?.length == 1) {
      this.singleRevalidationWarning = this.revalidationResponse?.fieldsUpdated[0].reason;
      return true;
    }
    else if (this.revalidationResponse?.fieldsUpdated?.length > 1) {
      this.multipleRevalidationWarning = this.revalidationResponse?.fieldsUpdated.map(x => {
        return x.reason;
      });
      return true;
    }
  }

  get displayRevalidationError() {
    if (this.revalidationResponse?.errors?.length == 1) {
      this.singleRevalidationError = this.revalidationResponse?.errors[0]?.reason ?? '';
      return true;
    }
    else if (this.revalidationResponse?.errors?.length > 1) {
      this.multipleRevalidationError = this.revalidationResponse?.errors.map(x => {
        return x.reason;
      });
      return true;
    }
  }

  get hasEauthAccess() {
    return this.hasWireEauthAccess || this.hasItEauthAccess || this.displayClientAuthorizationSection || this.multiEauthEligible;
  }

  get clientAuthorizationNeeded() {
    return this.wireClientAuthorizationNeeded || this.itClientAuthorizationNeeded || this.checkClientAuthorizationNeeded || (this.multiAccountClientAuthorizationNeeded && this.transferType !== transferTypes.CASH);
  }

  get isAddAchProfile(): boolean {
    // TODO: Once we start showing recurring profiles in the list, we'll need to check and make sure it's an on-request profile AND recurring frequency
    return this.isRecurring || this.extraPrompts?.frequency?.toLowerCase() === frequencyTypes.recurring.toLowerCase();
  }

  get multiAccountClientAuthorizationNeeded() {
    return this.itsInfo.multipleToJournalsList.some(
      (isClientAuth) => isClientAuth.clientAuthorizationNeeded
    );
  }

  get multiEauthEligible() {
    return this.itsInfo.multipleToJournalsList.some(
      (isEauth) => isEauth.eauthAccess
    );
  }

  get displayTrustCommentWarning(): boolean {
    let trustComment = this.transactionForm?.transactionDetails?.trustComment;
    return (trustComment !== null && trustComment !== undefined && trustComment !== '');
  }

  // if true txn is non iso compliant for release (can't release)
  // if false txn is iso compliant for release (can release)
  get isNonIsoCompliantTransactionReleasorFlow(): boolean {
    // If ISO compliant, always allow (return false)
    if (this.isISOCompliant) {
      return false;
    }
    // If non-ISO, only allow if SLOA or BSLOA is used
    let isSloaOrBsloa = this.extraPrompts?.useStandingAuth?.toLowerCase() === 'yes' ||
      this.extraPrompts?.useBundledStandingAuth?.toLowerCase() === 'yes';
    return this.transactionType === transactionTypes.wire &&
      this.isInitiateAndReleaseFlowFromTable &&
      !isSloaOrBsloa;
  }

  // if this is updated and change affects wires, will also need to update the Edit link in transaction-details-wire-condensed.component.ts
  get isEditEnabled(): boolean {
    return !this.isInitiateAndReleaseFlowFromTable
      || this.isOneTimeTotalDist || this.isChecksBundledOneTimeTotalDist || this.is401kToAccount;
  }

  get isBackButtonEnabled(): boolean {
    return this.isInitiateAndReleaseFlowFromTable
      && !this.isOneTimeTotalDist
      && !this.isChecksBundledOneTimeTotalDist
      && !this.is401kToAccount;
  }

  get showAcknowledgementSection(): boolean {
    return (!this.hasWireVerifyError &&
      !this.hasItVerifyError &&
      !this.revalidationStatusInvalid &&
      !this.isInitiator &&
      !this.hasServiceErrorFORINRTable &&
      !this.isNonIsoCompliantTransactionReleasorFlow &&
      !(this.multipleVerifyErrors.length > 0 && this.isInitiateAndReleaseFlowFromTable)) ||
      this.isOneTimeTotalDist;
  }

  get showSubmitButton(): boolean {
    return !this.hasWireVerifyError &&
      !this.hasItVerifyError &&
      !this.revalidationStatusInvalid &&
      !this.isInitiator &&
      !this.hasServiceErrorFORINRTable &&
      !this.isNonIsoCompliantTransactionReleasorFlow &&
      !(this.multipleVerifyErrors.length > 0 && this.isInitiateAndReleaseFlowFromTable) &&
      !this.isOneTimeTotalDist &&
      !this.isChecksBundledOneTimeTotalDist &&
      !this.is401kToAccount;
  }

  get showCreatePDFButton(): boolean {
    if (this.transactionType === transactionTypes.internalTransfer) {
      return this.is401kToAccount || this.isOneTimeTotalDist;
    }
    if (this.transactionType === transactionTypes.check) {
      return this.isChecksOneTimeTotalDist || this.isChecksBundledOneTimeTotalDist;
    }
    else {
      return false;
    }
  }

  get showOptions(): boolean {
    if (this.regType === "Conserv" || this.regType === "Guardian" || this.is401kToAccount) {
      return false;
    }
    else if (this.transactionType === transactionTypes.check) {
      return (!this.hideSaveTemplate && !this.isChecksOneTimeTotalDist);
    }
    else {
      return !this.hideSaveTemplate;
    }
  }

  get isCashTransaction(): boolean {
    return this.transferType === transferTypes.CASH;
  }

  get isRothSimpleAgeIntoQualifiedDistributionCode(): boolean {
    return (this.achInfo?.defaultDistributionReason === distributionReasons.exceptionApplies && this.achInfo?.distributionReason === distributionReasons.qualified);
  }

  submitAndCreateToggled(toggled: boolean) {
    this.store.dispatch(ReviewPageActions.submitAndCreateToggled({ isSubmitAndCreate: toggled }));
  }

  isInitReleaseFlowFromTableVerifyFailure(errorName: string) {
    return (errorName == ApiEndpointType.initReleaseByDraftId || errorName.toLocaleLowerCase().includes('verify')) && this.isInitiateAndReleaseFlowFromTable;
  }

  whichAchInfoUpdated(): string[] {
    if (this.transactionType !== transactionTypes.ach || this.isRecurring || !this.isIra || this.transferDirection.toLowerCase() === transactionDirection.in.toLowerCase()) {
      return [];
    }
    let result: string[] = [];
    if (this.grossNetUpdatedByVerify) {
      result.push('Gross/Net');
    }
    if (this.distributionReasonUpdatedByVerify) {
      result.push('Distribution Code');
    }
    return result;
  }
}
